import React from "react";
import { useSelector } from "react-redux";
import { getProductType } from "../../redux/creators/threekitCreators";

export default function FabricProductImage({ side }) {
  const { productType, selectedProduct } = useSelector((state) => ({
    productType: getProductType(state),
    selectedProduct: state.threekit.selectedProduct,
  }));

  function hasProductImage() {
    return ["tshirt", "tshirt-youth", "tshirt-womens"].includes(
      productType
    );
  }

  function getTShirtImage(type) {
    let imgUrl = "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/";
    let color = selectedProduct.option2 || "White";
    color = color.split(" ");

    if (side == "front") {
      return type == "womens"
        ? imgUrl + "womens_" + color[0].toLowerCase() + ".png"
        : imgUrl + color[0].toLowerCase() + ".png";
    } else {
      return type == "womens"
        ? imgUrl + "back_womens_" + color[0].toLowerCase() + ".png"
        : imgUrl + "back_" + color[0].toLowerCase() + ".png";
    }
  }

  function getSourceImage() {
    switch (productType) {
      case "tshirt":
        return getTShirtImage("mens");
      case "tshirt-youth":
        return getTShirtImage("youth");
      case "tshirt-womens":
        return getTShirtImage("womens");
      default:
        return "";
    }
  }

  return (
    <div className="product-image">
      {hasProductImage() && <img src={getSourceImage()}></img>}
    </div>
  );
}
